import React from "react"
import Table from "../../../components/common/Table"
import { TableHeaderColumn, TableRow, TableHeader, TableRowColumn, TableBody, IconButton, FontIcon } from "material-ui"
import strings from "../../../localization/strings"
import { ITimeoffRequestDocument, ETimeoffStatus, ELoggedInUserType, IUserDocument } from "../../../models"
import * as permissionHelper from "../../../helpers/permissionHelper"
import AuthenticationStore from "../../../stores/AuthenticationStore"
import AccountStore from "../../../stores/AccountStore"
import { green500 } from "material-ui/styles/colors"
import * as timeoffHelper from "../../../helpers/timeoffHelper"

interface IProps {
	employee: IUserDocument
	total: number
	limit: number
	offset: number
	limitOption: number[]
	leaveRequests: ITimeoffRequestDocument[]
	selectedLeaveRequests: ITimeoffRequestDocument[]
	loggedInUserType: ELoggedInUserType
	onPageClick(offset: number): void
	onLimitChange(limit: number): void
	handleUpdate(leaveRequest: ITimeoffRequestDocument): void
	handleSelect(leaveRequests: ITimeoffRequestDocument[]): void
	handleNotesDrawer(leaveRequestId: string): void
}

const UserDetailLeaveTrackingTable: React.SFC<IProps> = (props: IProps) => {
	const selectable =
		props.loggedInUserType === ELoggedInUserType.Employee ||
		(props.employee.Id === AuthenticationStore.getLoggedInUser().Id ?
			true :
			(permissionHelper.hasPermission(AuthenticationStore.Permissions.LeaveTracking.DeleteUserLeaveTracking) ||
				permissionHelper.hasPermission(AuthenticationStore.Permissions.LeaveTracking.EditUserLeaveTracking))
		)
	return (
		<Table
			readonly={!selectable}
			items={props.leaveRequests}
			handleClickRow={props.handleUpdate}
			handleSelect={props.handleSelect}
			total={props.total}
			offset={props.offset}
			limit={props.limit}
			limitOptions={props.limitOption}
			onPageClick={props.onPageClick}
			onLimitChange={props.onLimitChange}
		>
			<TableHeader>
				<TableRow>
					<TableHeaderColumn style={{ textAlign: "left" }}>{strings.Status}</TableHeaderColumn>
					<TableHeaderColumn style={{ textAlign: "left" }}>{strings.Title}</TableHeaderColumn>
					<TableHeaderColumn style={{ textAlign: "left" }}>{strings.Accrual}</TableHeaderColumn>
					<TableHeaderColumn style={{ textAlign: "left", width: 200 }}>{strings.Dates}</TableHeaderColumn>
					<TableHeaderColumn style={{ textAlign: "left" }}>{strings.TotalHours}</TableHeaderColumn>
					<TableHeaderColumn style={{ textAlign: "center" }}>{strings.Applied_Payroll}</TableHeaderColumn>
					<TableHeaderColumn style={{ textAlign: "left" }}>{strings.Applied_Hours}</TableHeaderColumn>
					{AccountStore.getPayRateTimeOffEditAllowed() && <TableHeaderColumn style={{ textAlign: "left" }}>{strings.Pay_Rate}</TableHeaderColumn>}
					<TableHeaderColumn style={{ textAlign: "center" }}>{strings.Notes}</TableHeaderColumn>
				</TableRow>
			</TableHeader>
			<TableBody showRowHover={true} deselectOnClickaway={false}>
				{props.leaveRequests.map((row, index) => {
					const dateStr = timeoffHelper.getTimeoffDateStr(row)
					return (
						<TableRow
							data-intercom-target={index === 0 && "menu-EmployeesLeaveTracking-openEmployeeLeaveTrackingDetails"}
							key={index}
							selected={props.selectedLeaveRequests.find(item => item.Id === row.Id) ? true : false}
						>
							<TableRowColumn style={{ textAlign: "left", cursor: "pointer" }}>
								{row.Status === ETimeoffStatus.Requested ? strings.Requested : row.Status === ETimeoffStatus.Approved ? strings.Approved : row.Status === ETimeoffStatus.Applied ? strings.Applied : strings.Denied}
							</TableRowColumn>
							<TableRowColumn style={{ textAlign: "left", cursor: "pointer" }} title={row.Description}>{row.Description}</TableRowColumn>
							<TableRowColumn style={{ textAlign: "left", cursor: "pointer" }}>{row.AccrualName}</TableRowColumn>
							<TableRowColumn style={{ textAlign: "left", cursor: "pointer", width: 200 }} title={dateStr}>
								{dateStr}
							</TableRowColumn>
							<TableRowColumn style={{ textAlign: "left", cursor: "pointer" }}>{row.TotalHours}</TableRowColumn>
							<TableRowColumn style={{ textAlign: "center", cursor: "pointer" }}>
								{row.AppliedInPayroll && <FontIcon className="fa fa-check" style={{ fontSize: 18, color: green500 }} />}
							</TableRowColumn>
							<TableRowColumn style={{ textAlign: "left", cursor: "pointer" }}>{row.AppliedInPayroll && row.AppliedHours}</TableRowColumn>
							{AccountStore.getPayRateTimeOffEditAllowed() && <TableRowColumn style={{ textAlign: "left", cursor: "pointer" }}>{!!row.PayRate && row.PayRate}</TableRowColumn>}
							<TableRowColumn style={{ textAlign: "center", cursor: "pointer" }}>
								<div onClick={e => e.stopPropagation()}>
									<IconButton onClick={() => props.handleNotesDrawer(row.Id)}>
										<FontIcon className="fa fa-comments" color={"rgba(97, 97, 97, 0.6)"} />
									</IconButton>
								</div>
							</TableRowColumn>
						</TableRow>
					)
				})}
			</TableBody>
		</Table>
	)
}

export default UserDetailLeaveTrackingTable
